import INVENTORY_API_BASE_URL from "../../config/api";
import "./managepurchase.css";
import { useState, useEffect } from "react";
import React from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";

function Managepurchase() {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getApproveDPO`).then((response) => {
      setData(response.data);
    });
  }, []);

  const filteredData = data.filter((row) => {
    const orderidMatch = row.shipmentid
      .toString()
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const skuMatch =
      Array.isArray(row.updatedQuantity) &&
      row.updatedQuantity.some((item) =>
        item.sku.toLowerCase().includes(searchQuery.toLowerCase())
      );
    return orderidMatch || skuMatch;
  });

  return (
    <div className="manageP">
      <div className="mpheading">
        <h4>Manage Purchase</h4>
      </div>
      <br />
      <input
        className="managesearch"
        type="text"
        placeholder="Search by Order ID or SKU"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      <div className="mpcontainer">
        <div className="mpcontent">
          <Table className="ManagePOtable">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Distributor Name</th>
                <th>SKU</th>
                <th>Image</th>
                <th>Title</th>
                <th>Medium</th>

                <th>Edition</th>
                <th>Current Stocks</th>
                <th>MRP</th>
                <th>Purchase Value</th>
                <th>Approved Quantity</th>
                <th>Order Value</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((row) => (
                <React.Fragment key={row.orderid}>
                  {Array.isArray(row.updatedQuantity) &&
                    row.updatedQuantity.map((item, itemIndex) => (
                      <tr key={`${item.date}-${itemIndex}`}>
                        {itemIndex === 0 && (
                          <>
                            <td rowSpan={row.Porder.length}>
                              {row.shipmentid}
                            </td>
                            <td rowSpan={row.Porder.length}>
                              {item.distributorName}
                            </td>
                          </>
                        )}
                        <td>{item.sku}</td>
                        <td>
                          <img
                            src={`https://d10idqgatxnd06.cloudfront.net/${item.img}`}
                            alt="image1"
                            width="100"
                            height="100"
                          />
                        </td>
                        <td>{item.title}</td>
                        <td>{item.Medium}</td>
                        <td>{formatDate(row.orderdate)}</td>
                        <td>{item.edition}</td>
                        <td>{item.currentstocks}</td>
                        <td>{item.mrp}</td>
                        <td>{(item.PurchaseValue || 0).toFixed(2)}</td>
                        <td>{item.approvedquantity}</td>
                        <td>{(item.approvedOrderValue || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                </React.Fragment>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}

export default Managepurchase;
